import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react';
import * as React from 'react';
import styles from './StudyFilterDropdown.module.css';

export interface StudyFilterDropdownPopupProps {
    isOpen: boolean;
    popupAnchor: HTMLElement | null;
    numberOfSelections: number;
}

export const StudyFilterDropdownPopup: React.FC<React.PropsWithChildren<StudyFilterDropdownPopupProps>> = props => {
    const { children, popupAnchor, isOpen } = props;

    const { refs, floatingStyles } = useFloating({
        elements: {
            reference: popupAnchor,
        },
        placement: 'bottom-start',
        middleware: [
            offset(8),
            flip({
                fallbackPlacements: ['bottom', 'top'],
            }),
            shift({
                padding: 32,
            }),
        ],
        strategy: 'fixed',
        whileElementsMounted: isOpen ? autoUpdate : undefined,
    });

    return (
        <div ref={refs.setFloating} className={styles.StudyFilterDropdownPopup} style={floatingStyles}>
            {children}
        </div>
    );
};
